import { render, staticRenderFns } from "./NoteListItem.vue?vue&type=template&id=53ed6d0e&scoped=true&"
import script from "./NoteListItem.vue?vue&type=script&lang=js&"
export * from "./NoteListItem.vue?vue&type=script&lang=js&"
import style0 from "./NoteListItem.vue?vue&type=style&index=0&id=53ed6d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed6d0e",
  null
  
)

component.options.__file = "NoteListItem.vue"
export default component.exports